import * as React from 'react'

import { ActivatePayload } from 'modules/app_store/lib/SubscriptionAddonInstaller'
import { APPS } from 'modules/billing/lib/types'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

import ActivateCompanySlug from './ActivateCompanySlug'
import ActivateCompetencies from './ActivateCompetencies'
import ActivateComplaints from './ActivateComplaints'
import ActivateDesky from './ActivateDesky'
import ActivateEmployeeOnboarding from './ActivateEmployeeOnboarding'
import ActivateExpensesReviewer from './ActivateExpensesReviewer'
import ActivateIdealdisc from './ActivateIdealdisc'
import ActivateLinkedInLimitedListings from './ActivateLinkedInLimitedListings'
import ActivatePayroll from './ActivatePayroll'

interface Props {
  subscriptionAddon: SubscriptionAddon
  onSuccess: (payload?: ActivatePayload | null | undefined) => Promise<boolean>
  onClose: () => void
}

const ActivateAddonModal = ({ subscriptionAddon, onSuccess, onClose }: Props) => {
  switch (subscriptionAddon.attributes.id) {
    case APPS.ats:
    case APPS.ats_careers_page:
      return <ActivateCompanySlug onSuccess={onSuccess} onClose={onClose} />

    case APPS.expenses:
      return <ActivateExpensesReviewer onSuccess={onSuccess} onClose={onClose} />

    case APPS.expenses_v2:
      return <ActivateExpensesReviewer onSuccess={onSuccess} onClose={onClose} />

    case APPS.payroll_bundle:
      return <ActivatePayroll onSuccess={onSuccess} onClose={onClose} />

    case APPS.competencies_custom_table:
      return <ActivateCompetencies onSuccess={onSuccess} onClose={onClose} />

    case APPS.complaints:
      return <ActivateComplaints onSuccess={onSuccess} onClose={onClose} />

    case APPS.employee_onboarding:
      return <ActivateEmployeeOnboarding onSuccess={onSuccess} onClose={onClose} />

    case APPS.desky:
      return <ActivateDesky onSuccess={onSuccess} onClose={onClose} />

    case APPS.linkedin_limited_listings:
      return <ActivateLinkedInLimitedListings onSuccess={onSuccess} onClose={onClose} />
    case APPS.ats_idealdisc:
      return <ActivateIdealdisc onSuccess={onSuccess} onClose={onClose} />
    default:
      return null
  }
}

export default ActivateAddonModal
